<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REPORTE PERSONALIZADO</v-card-title>            
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>                
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="2">
                        <date-picker class="dtpicker" v-model="fecha_inicio" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2">
                        <date-picker class="dtpicker" v-model="fecha_termino" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="punto_medicion"
                            :items="puntos_medicion"
                            item-text="nombre_punto"
                            item-value="id"
                            label="Punto de Medición"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarEquipos">
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="equipo"
                            :items="equipos"
                            item-text="nombre_equipo"
                            item-value="id"
                            label="Equipo"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarParametros">
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="parametro"
                            :items="parametros"
                            item-text="nombre_parametro"
                            item-value="parametros_id"
                            label="Parámetro"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="tipomp"
                            :items="tipomps"
                            item-text="tipo_materia_prima"
                            item-value="id"
                            label="Tipo Materia Prima"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="lote" label="Lote"></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="analista"
                            :items="analistas"
                            item-text="name"
                            item-value="id"
                            label="Analista"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="jefeturno"
                            :items="jefesturno"
                            item-text="name"
                            item-value="id"
                            label="Jefe Turno"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-btn @click="cargarDatos" outlined color="blue">Filtrar</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn @click="download" outlined color="green">Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-text>
                <v-data-table 
                    :headers="cabeceras"
                    :items="lista"
                    class="elevation-1"
                    dense
                >
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import {mapState,mapMutations} from 'vuex'
    //import Tabla from '@/components/shared/Tabla.vue'
    import Data_Table from '@/components/shared/Data_Table.vue'
    import Modal from '@/components/shared/Modal.vue'
    import { GChart } from 'vue-google-charts'
    //datepicker vue2
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/es';
    import ModalAyudas from '@/components/shared/ModalAyudas.vue';

    // import axios from 'axios'
    export default {
        data:()=>({
            punto_medicion: {},
            puntos_medicion: [],
            equipos: [],
            equipo: {},
            parametros: [],
            parametro: {},
            fecha_inicio: new Date().toISOString().substr(0, 10),
            fecha_termino: new Date().toISOString().substr(0, 10),
            mostrar_fecha1: false,
            mostrar_fecha2: false,
            lote: '',
            analistas:[],
            analista:{},
            jefesturno:[],
            jefeturno:{},
            tipomps:[],
            tipomp:{},
            url_excel: '',
            show_excel: false,
            cabeceras: [
                {
                    text: 'Fecha',
                    align: 'center',
                    sortable: true,
                    value: 'fecha',
                },
                {
                    text: 'Materia Prima',
                    align: 'center',
                    sortable: true,
                    value: 'materia_prima',
                },
                {
                    text: 'Analista',
                    align: 'center',
                    sortable: true,
                    value: 'analista',
                },
                {
                    text: 'Jefe Turno',
                    align: 'center',
                    sortable: true,
                    value: 'jefe_turno',
                },
                {
                    text: 'Punto Medicion',
                    align: 'center',
                    sortable: true,
                    value: 'punto_medicion',
                },
                {
                    text: 'Equipo',
                    align: 'center',
                    sortable: true,
                    value: 'equipo',
                },
                {
                    text: 'Parametro',
                    align: 'center',
                    sortable: true,
                    value: 'parametro',
                },
                {
                    text: 'Valor',
                    align: 'center',
                    sortable: true,
                    value: 'valor',
                }
            ],
            lista:[]
        }),
        created() {
            
        },
        mounted() {
            this.cargarPuntos();
            this.cargarAnalistas();
            this.cargarJefes();
            this.cargarTipoMp();
        },
        methods: {
            abrirAyudas(){
                const jiji = [
                    {   titulo:`Ayuda de Reporte Personalizado`,    tipo:`titulo`},
                    {   tipo:`label`,   texto:`En esta pantalla se muestra un listado de cada medición según el rango de fechas y los filtros indicados de forma personalizada.`},
                    {   tipo:`label`,   texto:`- El rango de fechas se selecciona arriba a la izquierda. El campo de fechas de la derecha es la fecha "desde" y el de la derecha es la fecha "hasta". También es posible filtrar por punto de medición, equipo, parámetro, tipo de materia prima, número de lote, analista y jefe de turno de forma opcional. Una vez indicados todos los filtros que se requieran, se debe pulsar el botón "Filtrar" para buscar toda la información.`},
                    {   tipo:`label`,   texto:`- Toda esta información se puede exportar en un excel pulsando el botón "Excel".`},
                ];
                Event.$emit('mostrar_alert',jiji);
            },
            async cargarPuntos(){
                let url = `${this.base_url}punto_medicion`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.puntos_medicion = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarEquipos(){
                let url = `${this.base_url}punto_medicion/equipos/${this.punto_medicion.id}`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.equipos = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarParametros(){
                let url = `${this.base_url}punto_medicion/parametros/${this.punto_medicion.id}/${this.equipo.id}`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.parametros = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarAnalistas(){
                let url = `${this.base_url}user/analistas`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.analistas = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarJefes(){
                let url = `${this.base_url}user/jefes`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.jefesturno = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarTipoMp(){
                let url = `${this.base_url}tipo_mps`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.tipomps = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarDatos(){
                this.url_excel = '';
                //this.mostrarLoading('Cargando Datos...');
                this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

                if(this.punto_medicion.id == undefined) this.punto_medicion.id = 0;
                if(this.equipo.id == undefined) this.equipo.id = 0;
                if(this.parametro.parametros_id == undefined) this.parametro.parametros_id = 0;
                if(this.tipomp.id == undefined) this.tipomp.id = 0;
                if(this.analista.id == undefined) this.analista.id = 0;
                if(this.jefeturno.id == undefined) this.jefeturno.id = 0;
                if(this.lote == "") this.lote = "0";
                //console.log(this.fecha_inicio);
                let url = `${this.base_url}resultados/personalizado/${this.fecha_inicio}/${this.fecha_termino}/${this.punto_medicion.id}/${this.equipo.id}/${this.parametro.parametros_id}/${this.tipomp.id}/${this.lote}/${this.analista.id}/${this.jefeturno.id}`;
                await this.axios.get(url, this.headers).then((response)=>{
                    let resp = response.data.data;
                    this.lista = resp.datos;
                    this.url_excel = resp.url_excel;
                    this.ocultarLoading();
                }).catch((error)=>{
                    console.log(error);
                    this.ocultarLoading();
                })
            },
            download(){
                window.location.href = this.url_excel;
            },

            ...mapMutations(['mostrarLoading','ocultarLoading'])
        },
        computed: {
            ...mapState(['base_url','headers']),

            fecha_formateada1 () {
                return this.fecha_inicio ? this.moment(this.fecha_inicio).format('DD-MM-YYYY') : '';
            },

            fecha_formateada2 () {
                return this.fecha_termino ? this.moment(this.fecha_termino).format('DD-MM-YYYY') : '';
            }
        },
        components:{
            'modal':Modal,
            'data-table':Data_Table,
            GChart,
            DatePicker,
            'modal-ayuda': ModalAyudas,
        }
    }
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
        margin-top: 18px;
    }
</style>